import { Stack, StackSeparator, Box, Heading, Text } from '@chakra-ui/react';
import { NavLink, useParams } from 'react-router-dom';
import {
  DialogBackdrop,
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogHeader,
  DialogRoot,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { DailogProps } from '@/lib/types';
import { FIELD_TYPES } from '@/lib/constants';

interface Props extends DailogProps {
  onSuccess(): void;
}

export default function CreateFieldModal({ isOpen, onClose }: Props) {
  const { workspaceId } = useParams();

  return (
    <DialogRoot lazyMount open={isOpen} onOpenChange={onClose}>
      <DialogBackdrop />
      <DialogTrigger />
      <DialogContent>
        <DialogCloseTrigger />
        <DialogHeader>
          <DialogTitle>Which type of Field would you like to create?</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Stack separator={<StackSeparator />} gap={4} p={4}>
            {FIELD_TYPES.map((type) => (
              <NavLink key={type.id} to={`/${workspaceId}/fields/create/${type.id}`}>
                <Box>
                  <Heading size={'sm'}>{type.name}</Heading>
                  <Text fontSize={'xs'}>{type.description}</Text>
                </Box>
              </NavLink>
            ))}
          </Stack>
        </DialogBody>
      </DialogContent>
    </DialogRoot>
  );
}
